
import styled from 'styled-components'


export const ButtonClose = styled.button`
    all: unset;
    height: 40px;
    width: 40px;
    color: #02103F;
    font-weight: bold;
    font-size: 32px; 
    line-height: 1;  
    cursor: pointer; 
`